<template>
    <div>
        <b-card>
            <b-card-header><b>Test Data Details:</b></b-card-header>
            <b-card-body>
                <b-form>
                    <b-row>
                        <!-- <b-col cols="1"></b-col> -->
                        <b-col cols="6">                       
                            <b-form-group label="Load ID:">
                                <b-form-input type="text" v-model="loadId" name="loadId" readonly></b-form-input>
                            </b-form-group>
                        </b-col>
                        <!-- <b-col cols="2"></b-col> -->
                        <b-col cols="6">
                            <b-form-group label="AWB Number:">
                                <b-form-input type="text" v-model="awbNumber" name="awbNumber" readonly></b-form-input>
                            </b-form-group>
                        </b-col>
                        <!-- <b-col cols="1"></b-col> -->
                    </b-row>

                    <b-row>
                        <b-col cols="6">                       
                            <b-form-group label="Source ID:">
                                <b-form-select @change="showCompanyDetails(sourceId,'source')" v-model="sourceId" id="sourceId" name="sourceId" placement="Select Source ID" required>
                                    <option :value="null">--Select Source ID--</option>
                                    <option v-for="user in users" :value="user.userid" :key="user.userid" >{{ user.userid }}</option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>

                        <!-- <b-col cols="6">                       
                            <b-form-group label="Source ID:">
                                <v-select
                                    v-model="sourceId"
                                    :options="users"
                                    label="userid"
                                    placeholder="--Select Source ID--"
                                    @input="showCompanyDetails(sourceId, 'source')"
                                ></v-select>
                            </b-form-group>
                        </b-col> -->

                        <b-col cols="6">
                            <b-form-group label="Destination ID:">
                                <b-form-select @change="showCompanyDetails(destinationId,'destination')" v-model="destinationId" id="destinationId" name="destinationId" placement="Select Destination ID" required>
                                    <option :value="null">--Select Destination ID--</option>
                                    <option v-for="user in users" :value="user.userid" :key="user.userid" >{{ user.userid }}</option>
                                </b-form-select>
                            </b-form-group>
                            <!-- <small v-if="sourceId && destinationId && sourceId === destinationId" class="text-danger">Source and destination ID should be different.</small> -->
                        </b-col>
                        
                    </b-row>

                    <b-row class="row-wrapper">
                        <b-col cols="6" v-if="sourceCompany && sourceAddress">
                            <div class="source-div">
                                <p><b>Source Company:</b> {{ sourceCompany }}</p>
                                <p><b>Source Address:</b> {{ sourceAddress }}</p>
                                <p><b>Source Pincode:</b> {{ sourcePincode }}</p>
                            </div>
                        </b-col>
                        <b-col cols="6" v-if="destinationCompany && destinationAddress" class="destination-col">
                            <div class="destination-div">
                                <p><b>Destination Company:</b> {{ destinationCompany }}</p>
                                <p><b>Destination Address:</b> {{ destinationAddress }}</p>
                                <p><b>Destination pincode:</b> {{ destinationPincode }}</p>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="6">                       
                            <b-form-group label="Source Type:">
                                <b-form-select v-model="source" id="source" name="source" placement="Select Source Type" required>
                                    <option :value="null">--Select Source Type--</option>
                                    <option v-for="sType in sourceTypes" :value="sType.value" :key="sType.id" >{{ sType.name }}</option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Dispatch Date:">              
                                <b-form-input type="date" v-model="dispatchDate" name="dispatchDate" :trigger="'focus'"></b-form-input>                               
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="6">                       
                            <b-form-group label="Boxes:">
                                <b-form-input type="number" v-model="boxes" name="boxes" placeholder="Number of Boxes" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" class="align-self-end"> 
                            <b-button @click.prevent="submitData" type="submit" variant="primary">
                                <span v-if="isBusy">Loading...</span>
                                <span v-else>Submit</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'

    export default{
        name: 'testData',
        data: function(){
            return{
                loadId: '',
                awbNumber: '',
                sourceId: null,
                destinationId: null,
                users: [],
                destinationOptions: [],
                source: null,
                sourceTypes: [
                    { id: 1, name: 'Warehouse', value: 'Warehouse' },
                    { id: 2, name: 'Vendor', value: 'Vendor' },
                    { id: 3, name: 'Stockist', value: 'Stockist' },
                ],
                dispatchDate: '',
                boxes: '',
                // sourceDetails: {
                //     company:null,
                //     address:null,
                //     pincode:null
                // },

                sourceCompany : null,
                sourceAddress : null,
                sourcePincode : null,
                sourceType : null,
                sourceCity : null,
                sourceState : null,

                // destinationDetails: {
                //     company:null,
                //     address:null,
                //     pincode:null
                // },

                destinationCompany : null,
                destinationAddress : null,
                destinationPincode : null,
                destinationType : null,
                destinationCity : null,
                destinationState : null,

                result: [],
                isBusy: false,
            }
        },
        created(){
            this.getTestDetails();
            this.getIdDetails();
        },
        methods:{
            getTestDetails: function(){
                var userdata = localStorage.getItem('userData')
                var userInfo = JSON.parse(userdata)

                // const Obj = {

                // }

                this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/generateRandomAWBAndLoadId`)
                .then(response => {
                    // console.log('RandomAWBAndLoadId-----> ',response)
                    // console.log('test_data---> ', response.data.returnvalue);
                    this.loadId = response.data.returnvalue[0];
                    this.awbNumber = response.data.returnvalue[1];
                })
                .catch(error => {
                    console.error('Error:', error);
                });
            },

            getIdDetails: function(){
                const Obj = {

                }

                this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getListOfUserId`,Obj)
                .then(response=> {
                    console.log('Source Id Details ---->',response);
                    this.result = response.data;

                    if(this.result.returnmsg === 'successful'){
                        this.users = this.result.returnvalue;
                        // console.log('users---> ',users);
                    }
                    else{
                        this.users = [];
                    }
                })
                .catch(error => {
                    console.error('Error:',error);
                })
            },

            showCompanyDetails: function(sourceId,type){
                
                const Obj = {
                    id: sourceId,
                    type: type
                }

                this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDetailsForSelectedId`,Obj)
                .then(response => {
                    this.result = response.data;

                    // console.log('company address---> ',response.data.returnvalue[0].sourceaddress);

                    if(this.result.returnmsg === 'successful'){
                        if(type === 'source'){
                            this.sourceCompany = response.data.returnvalue[0].sourcecompanyname;
                            this.sourceAddress = response.data.returnvalue[0].sourceaddress;
                            this.sourcePincode = response.data.returnvalue[0].sourcepincode;
                            this.sourceType = response.data.returnvalue[0].sourcetype;
                            this.sourceCity = response.data.returnvalue[0].sourcecity;
                            this.sourceState = response.data.returnvalue[0].sourcestate;
                        }
                        else{
                            this.destinationCompany = response.data.returnvalue[0].destinationcompanyname;
                            this.destinationAddress = response.data.returnvalue[0].destinationaddress;
                            this.destinationPincode = response.data.returnvalue[0].destinationpincode;
                            this.destinationType = response.data.returnvalue[0].destinationtype;
                            this.destinationCity = response.data.returnvalue[0].destinationcity;
                            this.destinationState = response.data.returnvalue[0].destinationstate;
                        }
                    }
                    else{
                        if(type === 'source'){
                            this.sourceCompany = null;
                            this.sourceAddress = null;
                            this.sourcePincode = null;
                            this.sourceType = null;
                            this.sourceCity = null;
                            this.sourceState = null;
                        }
                        else{
                            this.destinationCompany = null;
                            this.destinationAddress = null;
                            this.destinationPincode = null;
                            this.destinationType = null;
                            this.destinationCity = null;
                            this.destinationState = null;
                        }
                    }
                })
            },

            submitData: function(){
                if (!this.sourceId || !this.destinationId || !this.source  || !this.boxes) {
                    this.$fire({
                        text: "Please fill all required fields",
                        type: "warning",
                        timer: 3000
                    });
                    return; 
                }

                this.isBusy = true;

                const Obj = {
                    loadId : this.loadId,
                    awbNumber: this.awbNumber,
                    sourceId: this.sourceId,
                    destinationId: this.destinationId,
                    sourceType: this.source,
                    dispatchDate: this.dispatchDate,
                    MPSCount: this.boxes,
                    // sourceDetails: this.sourceDetails,
                    // destinationDetails: this.destinationDetails,
                    sourcecompany: this.sourceCompany,
                    sourceaddress: this.sourceAddress,
                    sourcepincode: this.sourcePincode,
                    sourcetype: this.sourceType,
                    sourcecity: this.sourceCity,
                    sourcestate: this.sourceState,

                    destinationcompany: this.destinationCompany,
                    destinationaddress: this.destinationAddress,
                    destinationpincode: this.destinationPincode,
                    destinationtype: this.destinationType,
                    destinationcity: this.destinationCity,
                    destinationstate: this.destinationState
                }


                this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/addDetailsForTestDataManifestation`,Obj)
                .then(response => {
                    this.result = response.data;

                    if(this.result.returnmsg === 'Successful'){
                        this.$fire({
                            text:"Test Data submitted Successfully!!! ",
                            type: "success",
                            timer: 30000
                        });
                        this.clearForm();
                    }
                    else{
                        this.$fire({
                            text:"Something went wrong!!! ",
                            type: "error",
                            timer: 30000
                        });
                    }
                    
                    this.isBusy = false;
                })
                .catch(error => {
                    console.error('Error:',error);
                    this.isBusy = false;
                })
            },

            clearForm: function(){
                this.loadId = '',
                this.awbNumber = '';               
                this.sourceId = null;
                this.destinationId = null;
                this.source = null;
                this.dispatchDate = '';
                this.boxes = '';
                // this.sourceDetails = {
                //     company: null,
                //     address: null,
                //     pincode: null
                // };
                // this.destinationDetails = {
                //     company: null,
                //     address: null,
                //     pincode: null
                // };
                this.sourceCompany = null;
                this.sourceAddress = null;
                this.sourcePincode = null;
                this.sourceType = null;
                this.sourceCity = null;
                this.sourceState = null;

                this.destinationAddress = null;
                this.destinationCompany = null;
                this.destinationPincode = null;
                this.destinationType = null;
                this.destinationCity = null;
                this.destinationState = null;
                this.getTestDetails();
            }
        }
    }

</script>

<style>

.row-wrapper {
    display: flex;
    justify-content: space-between;
}

.destination-col {
    margin-left: auto;
}

.source-div {
    background-color: #e4e5e6; 
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 10px;
}
.destination-div {
    background-color: #e4e5e6; 
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 10px;
}
</style>